import React, { useEffect, useState, useCallback, useMemo } from 'react';
import api from '../services/api';

// ==================================================================================
// ÍCONES PREMIUM / APP NATIVO
// ==================================================================================
const Icons = {
  ArrowLeft: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  Plus: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Close: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Edit: () => (
    <svg width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  ),
  Trash: () => (
    <svg width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  ),
  Pause: () => (
    <svg width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <rect x="6" y="4" width="4" height="16" rx="1" />
      <rect x="14" y="4" width="4" height="16" rx="1" />
    </svg>
  ),
  Play: () => (
    <svg width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <polygon points="6 4 20 12 6 20 6 4" />
    </svg>
  ),
  Shield: () => (
    <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Check: () => (
    <svg width="19" height="19" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Alert: () => (
    <svg width="19" height="19" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Search: () => (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Users: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9.5" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
};

function resolverArrayApi(data, fallbackKey = '') {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (fallbackKey && Array.isArray(data?.[fallbackKey])) return data[fallbackKey];
  if (Array.isArray(data?.empresas)) return data.empresas;
  if (Array.isArray(data?.users)) return data.users;
  if (Array.isArray(data?.usuarios)) return data.usuarios;
  return [];
}

function normalizarId(valor) {
  if (!valor) return '';
  if (typeof valor === 'object') return String(valor._id || valor.id || '');
  return String(valor);
}

function getEmpresaCodigo(empresa = {}) {
  return String(empresa.codigoLoja || empresa.loja || '').trim();
}

function getEmpresaLabel(empresa = {}) {
  const nome = empresa.nome || 'Empresa';
  const unidade = empresa.unidade && empresa.unidade !== 'Matriz' ? ` - ${empresa.unidade}` : '';
  return `${nome}${unidade}`;
}

function ordenarMatrizPrimeiro(a, b) {
  const aMatriz = String(a.unidade || '').toLowerCase() === 'matriz';
  const bMatriz = String(b.unidade || '').toLowerCase() === 'matriz';
  if (aMatriz && !bMatriz) return -1;
  if (!aMatriz && bMatriz) return 1;
  return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
}

function getEmpresaMatriz(empresas = []) {
  const ativas = empresas.filter((empresa) => empresa.ativo !== false);
  return [...ativas].sort(ordenarMatrizPrimeiro)[0] || ativas[0] || null;
}

function getEmpresaDoUsuario(user = {}, empresas = []) {
  const id = normalizarId(user.empresaId);
  const loja = String(user.loja || '').trim();

  return (
    empresas.find((empresa) => normalizarId(empresa._id) === id) ||
    empresas.find((empresa) => getEmpresaCodigo(empresa) === loja) ||
    null
  );
}

export default function Cadastro() {
  const [users, setUsers] = useState([]);
  const [empresas, setEmpresas] = useState([]);

  const [nomeCompleto, setNomeCompleto] = useState('');
  const [usuario, setUsuario] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [tipo, setTipo] = useState('vendedor');
  const [empresaSelecionadaId, setEmpresaSelecionadaId] = useState('');

  const [msg, setMsg] = useState({ texto: '', tipo: '' });
  const [editandoId, setEditandoId] = useState(null);
  const [formAberto, setFormAberto] = useState(false);
  const [busca, setBusca] = useState('');

  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [saving, setSaving] = useState(false);

  const empresasAtivas = useMemo(() => empresas.filter((emp) => emp.ativo !== false), [empresas]);
  const empresaMatriz = useMemo(() => getEmpresaMatriz(empresasAtivas), [empresasAtivas]);

  const empresaSelecionada = useMemo(() => (
    empresasAtivas.find((emp) => normalizarId(emp._id) === empresaSelecionadaId) ||
    empresasAtivas.find((emp) => getEmpresaCodigo(emp) === empresaSelecionadaId) ||
    null
  ), [empresasAtivas, empresaSelecionadaId]);

  const usersFiltrados = useMemo(() => {
    const termo = busca.trim().toLowerCase();

    if (!termo) return users;

    return users.filter((user) => {
      const loja = user.loja || user.empresaId?.unidade || user.empresaId?.nome || '';
      const texto = `${user.nomeCompleto || ''} ${user.usuario || ''} ${user.email || ''} ${user.tipo || ''} ${loja}`.toLowerCase();
      return texto.includes(termo);
    });
  }, [users, busca]);

  const totalAtivos = useMemo(() => users.filter((user) => user.ativo !== false).length, [users]);
  const totalAdmins = useMemo(() => users.filter((user) => user.tipo === 'admin').length, [users]);

  const showMsg = useCallback((texto, tipo = 'sucesso') => {
    setMsg({ texto, tipo });
    window.clearTimeout(window.__cadastroToastTimer);
    window.__cadastroToastTimer = window.setTimeout(() => setMsg({ texto: '', tipo: '' }), 3000);
  }, []);

  const loadUsers = useCallback(async () => {
    setLoadingUsers(true);

    try {
      const response = await api.get('/users');
      setUsers(Array.isArray(response.data) ? response.data : resolverArrayApi(response.data, 'users'));
    } catch (error) {
      showMsg('Erro ao carregar os acessos.', 'erro');
    } finally {
      setLoadingUsers(false);
    }
  }, [showMsg]);

  const loadEmpresas = useCallback(async () => {
    setLoadingEmpresas(true);

    try {
      const response = await api.get('/empresas', { params: { comResumo: true } });
      const lista = resolverArrayApi(response.data, 'empresas');
      setEmpresas(lista);

      setEmpresaSelecionadaId((atual) => {
        if (atual) return atual;

        const primeiraAtiva = lista.find((emp) => emp.ativo !== false) || lista[0];
        return primeiraAtiva ? normalizarId(primeiraAtiva._id) : '';
      });
    } catch (error) {
      showMsg('Erro ao carregar empresas.', 'erro');
    } finally {
      setLoadingEmpresas(false);
    }
  }, [showMsg]);

  useEffect(() => {
    loadUsers();
    loadEmpresas();
  }, [loadUsers, loadEmpresas]);

  useEffect(() => {
    if (!formAberto) return;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') fecharFormulario();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formAberto]);

  const getInitials = (name) => {
    if (!name) return 'U';

    const parts = name.trim().split(' ').filter(Boolean);

    if (parts.length === 0) return 'U';
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  function limparFormulario() {
    setEditandoId(null);
    setNomeCompleto('');
    setUsuario('');
    setEmail('');
    setSenha('');
    setTipo('vendedor');

    const primeiraAtiva = empresasAtivas[0];
    setEmpresaSelecionadaId(primeiraAtiva ? normalizarId(primeiraAtiva._id) : '');
  }

  function abrirNovoAcesso() {
    limparFormulario();
    setFormAberto(true);
  }

  function fecharFormulario() {
    setFormAberto(false);
    setTimeout(() => limparFormulario(), 180);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);

    try {
      if (!nomeCompleto || !tipo || !empresaSelecionadaId || (!editandoId && (!usuario || !senha))) {
        showMsg('Preencha os campos obrigatórios.', 'erro');
        setSaving(false);
        return;
      }

      const payload = {
        nomeCompleto,
        usuario,
        email,
        tipo,
        empresaId: empresaSelecionadaId,
        empresaVinculoId: empresaSelecionadaId,
        loja: empresaSelecionada?.codigoLoja || '',
      };

      if (editandoId) {
        if (senha.trim()) payload.senha = senha;
        await api.put(`/users/${editandoId}`, payload);
        showMsg('Acesso atualizado com sucesso.');
      } else {
        payload.senha = senha;
        await api.post('/users', payload);
        showMsg('Acesso criado com sucesso.');
      }

      setFormAberto(false);
      limparFormulario();
      loadUsers();
    } catch (error) {
      showMsg(error.response?.data?.error || 'Erro na operação.', 'erro');
    } finally {
      setSaving(false);
    }
  }

  function editarUser(user) {
    setEditandoId(user._id);
    setNomeCompleto(user.nomeCompleto || '');
    setUsuario(user.usuario || '');
    setEmail(user.email || '');
    setTipo(user.tipo || 'vendedor');

    const emp = getEmpresaDoUsuario(user, empresasAtivas);
    setEmpresaSelecionadaId(emp ? normalizarId(emp._id) : normalizarId(user.empresaId) || '');

    setSenha('');
    setFormAberto(true);
  }

  async function toggleUserStatus(user) {
    const acao = user.ativo ? 'disable' : 'enable';

    if (!window.confirm(`Confirma a alteração de status de ${user.nomeCompleto}?`)) return;

    try {
      await api.put(`/users/${user._id}/${acao}`);
      loadUsers();
      showMsg('Status do acesso alterado.');
    } catch {
      showMsg('Erro ao alterar status.', 'erro');
    }
  }

  async function deletarUser(id) {
    if (window.prompt('ZONA DE PERIGO\nDigite DELETAR para confirmar:') !== 'DELETAR') return;

    try {
      await api.delete(`/users/${id}`);
      showMsg('Acesso removido.', 'aviso');
      loadUsers();
    } catch {
      showMsg('Erro ao deletar acesso.', 'erro');
    }
  }

  return (
    <div className="bank-app">
      <GlobalStyles />

      <div className="native-shell">
        <header className="native-header">
          <button type="button" onClick={() => window.history.back()} className="round-button" aria-label="Voltar">
            <Icons.ArrowLeft />
          </button>

          <div className="native-title">
            <span>Equipe</span>
            <strong>Controle de acessos</strong>
          </div>

          <button type="button" onClick={abrirNovoAcesso} className="round-button primary" aria-label="Novo acesso">
            <Icons.Plus />
          </button>
        </header>

        <main className="native-main">
          <section className="account-hero">
            <div>
              <p className="hero-eyebrow">Lumix Gestão</p>
              <h1>Acessos da equipe</h1>
              <span>{empresaMatriz ? getEmpresaLabel(empresaMatriz) : 'Unidades vinculadas'}</span>
            </div>

            <button type="button" className="hero-action" onClick={abrirNovoAcesso}>
              Novo acesso
            </button>
          </section>

          <section className="metric-grid">
            <div className="metric-card dark">
              <span>Total</span>
              <strong>{users.length}</strong>
              <small>membros cadastrados</small>
            </div>

            <div className="metric-card">
              <span>Ativos</span>
              <strong>{totalAtivos}</strong>
              <small>com acesso liberado</small>
            </div>

            <div className="metric-card">
              <span>Admins</span>
              <strong>{totalAdmins}</strong>
              <small>gestão completa</small>
            </div>
          </section>

          <section className="team-panel">
            <div className="panel-head">
              <div>
                <p>Extrato de acessos</p>
                <h2>Membros da equipe</h2>
              </div>

              <span>{usersFiltrados.length}</span>
            </div>

            <div className="search-pill">
              <Icons.Search />
              <input
                type="text"
                value={busca}
                onChange={(event) => setBusca(event.target.value)}
                placeholder="Buscar por nome, usuário ou unidade"
              />
            </div>

            <div className="team-list">
              {loadingUsers ? (
                <div className="state-box">
                  <div className="loader-dot" />
                  <p>Carregando acessos...</p>
                </div>
              ) : usersFiltrados.length === 0 ? (
                <div className="state-box">
                  <Icons.Users />
                  <p>Nenhum acesso encontrado.</p>
                  <button type="button" onClick={abrirNovoAcesso}>Cadastrar primeiro acesso</button>
                </div>
              ) : (
                usersFiltrados.map((user) => {
                  const lojaStr = user.loja || user.empresaId?.unidade || user.empresaId?.nome || 'Não definida';
                  const isAdmin = user.tipo === 'admin';
                  const ativo = user.ativo !== false;

                  return (
                    <article key={user._id} className={`person-card ${!ativo ? 'inactive' : ''}`}>
                      <div className="person-main">
                        <div className={`person-avatar ${isAdmin ? 'admin' : ''}`}>
                          {getInitials(user.nomeCompleto)}
                        </div>

                        <div className="person-copy">
                          <div className="person-name-line">
                            <h3>{user.nomeCompleto}</h3>
                            {isAdmin && (
                              <span className="admin-pill">
                                <Icons.Shield />
                                Admin
                              </span>
                            )}
                          </div>

                          <p>@{user.usuario || 'sem-usuario'} · {lojaStr}</p>

                          {user.email && <small>{user.email}</small>}
                        </div>
                      </div>

                      <div className="person-side">
                        <span className={`native-status ${ativo ? 'on' : 'off'}`}>
                          {ativo ? 'Ativo' : 'Pausado'}
                        </span>

                        <div className="person-actions">
                          <button type="button" onClick={() => editarUser(user)} className="mini-action" title="Editar">
                            <Icons.Edit />
                          </button>

                          <button
                            type="button"
                            onClick={() => toggleUserStatus(user)}
                            className={`mini-action ${ativo ? 'warning' : 'success'}`}
                            title={ativo ? 'Pausar' : 'Ativar'}
                          >
                            {ativo ? <Icons.Pause /> : <Icons.Play />}
                          </button>

                          <button type="button" onClick={() => deletarUser(user._id)} className="mini-action danger" title="Excluir">
                            <Icons.Trash />
                          </button>
                        </div>
                      </div>
                    </article>
                  );
                })
              )}
            </div>
          </section>
        </main>
      </div>

      {msg.texto && (
        <div className={`native-toast toast-${msg.tipo}`}>
          {msg.tipo === 'erro' ? <Icons.Alert /> : <Icons.Check />}
          <span>{msg.texto}</span>
        </div>
      )}

      {formAberto && (
        <div className="sheet-layer" role="presentation">
          <button type="button" className="sheet-backdrop" onClick={fecharFormulario} aria-label="Fechar formulário" />

          <section className="native-sheet" role="dialog" aria-modal="true" aria-label={editandoId ? 'Editar acesso' : 'Novo acesso'}>
            <div className="sheet-grabber" />

            <div className="sheet-head">
              <div>
                <p>{editandoId ? 'Editar membro' : 'Novo membro'}</p>
                <h2>{editandoId ? 'Atualizar acesso' : 'Criar acesso'}</h2>
              </div>

              <button type="button" onClick={fecharFormulario} className="round-button muted" aria-label="Fechar">
                <Icons.Close />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="sheet-form">
              <div className="floating-field">
                <input
                  type="text"
                  value={nomeCompleto}
                  onChange={(event) => setNomeCompleto(event.target.value)}
                  placeholder=" "
                  required
                />
                <label>Nome completo</label>
              </div>

              <div className="floating-field">
                <input
                  type="text"
                  value={usuario}
                  onChange={(event) => setUsuario(event.target.value)}
                  placeholder=" "
                  required={!editandoId}
                />
                <label>Login do usuário</label>
              </div>

              <div className="floating-field">
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder=" "
                />
                <label>E-mail</label>
              </div>

              <div className="floating-field">
                <input
                  type="password"
                  value={senha}
                  onChange={(event) => setSenha(event.target.value)}
                  placeholder=" "
                  required={!editandoId}
                />
                <label>{editandoId ? 'Nova senha opcional' : 'Senha inicial'}</label>
              </div>

              <div className="choice-grid">
                <label className={`choice-card ${tipo === 'vendedor' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="tipo"
                    value="vendedor"
                    checked={tipo === 'vendedor'}
                    onChange={(event) => setTipo(event.target.value)}
                  />
                  <span>Vendedor</span>
                  <small>Acesso operacional</small>
                </label>

                <label className={`choice-card ${tipo === 'admin' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="tipo"
                    value="admin"
                    checked={tipo === 'admin'}
                    onChange={(event) => setTipo(event.target.value)}
                  />
                  <span>Administrador</span>
                  <small>Gestão completa</small>
                </label>
              </div>

              <div className="floating-field select-field">
                <select
                  value={empresaSelecionadaId}
                  onChange={(event) => setEmpresaSelecionadaId(event.target.value)}
                  required
                  disabled={loadingEmpresas}
                >
                  <option value="" disabled>{loadingEmpresas ? 'Carregando unidades...' : 'Selecione uma unidade'}</option>
                  {empresasAtivas.map((emp) => (
                    <option key={emp._id} value={normalizarId(emp._id)}>
                      {getEmpresaLabel(emp)}
                    </option>
                  ))}
                </select>
                <label>Unidade vinculada</label>
              </div>

              <button type="submit" className="sheet-submit" disabled={saving}>
                {saving ? 'Salvando...' : editandoId ? 'Salvar alteração' : 'Criar acesso'}
              </button>
            </form>
          </section>
        </div>
      )}
    </div>
  );
}

// ==================================================================================
// DESIGN: APP NATIVO LIMPO / FINTECH IOS
// Visual mais leve: sem cara de Google, sem Windows, sem excesso de cards ou efeitos.
// Mobile-first: formulário continua em bottom sheet para não ocupar metade da tela.
// ==================================================================================
const GlobalStyles = () => (
  <style>{`
    :root {
      --page: #f8f7f4;
      --surface: #ffffff;
      --surface-soft: #f1f0ed;
      --text: #141414;
      --muted: #77736d;
      --muted-2: #a19b93;
      --line: rgba(20, 20, 20, 0.08);
      --line-strong: rgba(20, 20, 20, 0.12);
      --brand: #141414;
      --brand-soft: #f3eee5;
      --green: #149b65;
      --red: #d83a45;
      --orange: #c47a24;
      --radius-xl: 28px;
      --radius-lg: 22px;
      --radius-md: 16px;
      --shadow-subtle: 0 12px 34px rgba(20, 20, 20, 0.055);
      --font: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', sans-serif;
    }

    * {
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;
    }

    html,
    body,
    #root {
      min-height: 100%;
    }

    body {
      margin: 0;
      color: var(--text);
      font-family: var(--font);
      background: var(--page);
      overflow-x: hidden;
    }

    button,
    input,
    select {
      font: inherit;
    }

    button {
      cursor: pointer;
    }

    .bank-app {
      min-height: 100vh;
      background: var(--page);
      padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom);
    }

    .native-shell {
      width: min(100%, 1080px);
      margin: 0 auto;
      padding: 14px 16px 36px;
    }

    .native-header {
      position: sticky;
      top: 0;
      z-index: 20;
      display: grid;
      grid-template-columns: 42px 1fr 42px;
      align-items: center;
      gap: 10px;
      padding: 8px 0 12px;
      background: rgba(248, 247, 244, 0.82);
      backdrop-filter: blur(18px);
      -webkit-backdrop-filter: blur(18px);
    }

    .native-title {
      min-width: 0;
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 1px;
    }

    .native-title span {
      color: var(--muted);
      font-size: 12px;
      font-weight: 650;
    }

    .native-title strong {
      color: var(--text);
      font-size: 17px;
      line-height: 1.1;
      letter-spacing: -0.035em;
      font-weight: 760;
    }

    .round-button {
      width: 42px;
      height: 42px;
      border: 1px solid var(--line);
      border-radius: 999px;
      display: grid;
      place-items: center;
      color: var(--text);
      background: rgba(255, 255, 255, 0.78);
      box-shadow: none;
      transition: transform 150ms ease, background 150ms ease, border-color 150ms ease;
    }

    .round-button:active {
      transform: scale(0.94);
      background: var(--surface-soft);
    }

    .round-button.primary {
      color: #fff;
      background: var(--brand);
      border-color: var(--brand);
    }

    .round-button.muted {
      background: var(--surface-soft);
      border-color: transparent;
    }

    .native-main {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .account-hero {
      min-height: auto;
      border-radius: var(--radius-xl);
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      color: var(--text);
      background: var(--surface);
      border: 1px solid var(--line);
      box-shadow: none;
      overflow: hidden;
    }

    .account-hero::before,
    .account-hero::after {
      display: none;
    }

    .hero-eyebrow {
      margin: 0 0 8px;
      color: var(--muted);
      font-size: 11px;
      font-weight: 720;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .account-hero h1 {
      margin: 0;
      max-width: 520px;
      color: var(--text);
      font-size: clamp(28px, 6vw, 44px);
      line-height: 0.98;
      letter-spacing: -0.065em;
      font-weight: 820;
    }

    .account-hero span {
      display: block;
      margin-top: 10px;
      color: var(--muted);
      font-size: 13px;
      line-height: 1.35;
      font-weight: 560;
    }

    .hero-action {
      flex: 0 0 auto;
      height: 42px;
      padding: 0 16px;
      border: 0;
      border-radius: 999px;
      color: #fff;
      background: var(--brand);
      font-size: 13px;
      font-weight: 720;
      box-shadow: none;
      transition: transform 150ms ease, opacity 150ms ease;
    }

    .hero-action:active {
      transform: scale(0.96);
    }

    .metric-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 10px;
    }

    .metric-card {
      min-height: 88px;
      padding: 14px 15px;
      border-radius: var(--radius-lg);
      background: var(--surface);
      border: 1px solid var(--line);
      box-shadow: none;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .metric-card.dark {
      color: var(--text);
      background: var(--surface);
      border-color: var(--line);
    }

    .metric-card span {
      color: var(--muted);
      font-size: 12px;
      font-weight: 650;
    }

    .metric-card strong {
      display: block;
      color: var(--text);
      font-size: 28px;
      line-height: 1;
      letter-spacing: -0.055em;
      font-weight: 800;
    }

    .metric-card small {
      color: var(--muted-2);
      font-size: 11px;
      line-height: 1.25;
      font-weight: 560;
    }

    .team-panel {
      padding: 14px;
      border-radius: var(--radius-xl);
      background: var(--surface);
      border: 1px solid var(--line);
      box-shadow: none;
    }

    .panel-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 14px;
      padding: 4px 2px 12px;
    }

    .panel-head p {
      margin: 0 0 4px;
      color: var(--muted);
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .panel-head h2 {
      margin: 0;
      color: var(--text);
      font-size: 21px;
      line-height: 1.05;
      letter-spacing: -0.055em;
      font-weight: 800;
    }

    .panel-head span {
      min-width: 34px;
      height: 34px;
      padding: 0 10px;
      border-radius: 999px;
      display: grid;
      place-items: center;
      color: var(--text);
      background: var(--surface-soft);
      border: 1px solid transparent;
      font-size: 13px;
      font-weight: 750;
    }

    .search-pill {
      height: 46px;
      margin-bottom: 10px;
      padding: 0 14px;
      display: flex;
      align-items: center;
      gap: 10px;
      border-radius: 999px;
      background: var(--surface-soft);
      border: 1px solid transparent;
      color: var(--muted);
    }

    .search-pill input {
      width: 100%;
      height: 100%;
      border: 0;
      outline: 0;
      background: transparent;
      color: var(--text);
      font-size: 14px;
      font-weight: 560;
    }

    .search-pill input::placeholder {
      color: var(--muted-2);
      font-weight: 520;
    }

    .team-list {
      display: flex;
      flex-direction: column;
      gap: 0;
      border-top: 1px solid var(--line);
    }

    .person-card {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: center;
      gap: 12px;
      padding: 13px 2px;
      border-radius: 0;
      background: transparent;
      border: 0;
      border-bottom: 1px solid var(--line);
      box-shadow: none;
      transition: opacity 150ms ease, background 150ms ease;
    }

    .person-card:last-child {
      border-bottom: 0;
    }

    .person-card:active {
      background: rgba(20, 20, 20, 0.025);
    }

    .person-card.inactive {
      opacity: 0.54;
    }

    .person-main {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .person-avatar {
      width: 44px;
      height: 44px;
      flex: 0 0 auto;
      border-radius: 16px;
      display: grid;
      place-items: center;
      color: var(--text);
      background: var(--brand-soft);
      border: 1px solid rgba(20, 20, 20, 0.04);
      font-size: 12px;
      font-weight: 800;
      letter-spacing: -0.03em;
    }

    .person-avatar.admin {
      color: #fff;
      background: var(--brand);
      border-color: var(--brand);
    }

    .person-copy {
      min-width: 0;
    }

    .person-name-line {
      display: flex;
      align-items: center;
      gap: 7px;
      min-width: 0;
    }

    .person-name-line h3 {
      min-width: 0;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--text);
      font-size: 15px;
      line-height: 1.18;
      font-weight: 740;
      letter-spacing: -0.032em;
    }

    .admin-pill {
      flex: 0 0 auto;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      height: 22px;
      padding: 0 7px;
      border-radius: 999px;
      color: #fff;
      background: var(--brand);
      font-size: 10px;
      font-weight: 760;
      letter-spacing: 0.01em;
      text-transform: uppercase;
    }

    .person-copy p {
      margin: 4px 0 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--muted);
      font-size: 12px;
      font-weight: 580;
    }

    .person-copy small {
      display: block;
      margin-top: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--muted-2);
      font-size: 11px;
      font-weight: 520;
    }

    .person-side {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .native-status {
      height: 26px;
      padding: 0 9px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-weight: 720;
    }

    .native-status.on {
      color: var(--green);
      background: rgba(20, 155, 101, 0.09);
    }

    .native-status.off {
      color: var(--muted);
      background: var(--surface-soft);
    }

    .person-actions {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .mini-action {
      width: 36px;
      height: 36px;
      border: 0;
      border-radius: 14px;
      display: grid;
      place-items: center;
      color: var(--muted);
      background: transparent;
      transition: transform 150ms ease, background 150ms ease, color 150ms ease;
    }

    .mini-action:hover {
      background: var(--surface-soft);
      color: var(--text);
    }

    .mini-action:active {
      transform: scale(0.92);
    }

    .mini-action.warning {
      color: var(--orange);
    }

    .mini-action.success {
      color: var(--green);
    }

    .mini-action.danger {
      color: var(--red);
    }

    .state-box {
      min-height: 170px;
      border-radius: var(--radius-lg);
      display: grid;
      place-items: center;
      text-align: center;
      padding: 24px;
      color: var(--muted);
      background: var(--surface-soft);
      border: 1px dashed var(--line-strong);
      margin-top: 12px;
    }

    .state-box p {
      margin: 10px 0 0;
      font-size: 13px;
      font-weight: 650;
    }

    .state-box button {
      margin-top: 14px;
      height: 40px;
      padding: 0 15px;
      border: 0;
      border-radius: 999px;
      color: #fff;
      background: var(--brand);
      font-size: 12px;
      font-weight: 720;
    }

    .loader-dot {
      width: 14px;
      height: 14px;
      border-radius: 999px;
      background: var(--brand);
      animation: pulseDot 1s ease-in-out infinite;
    }

    @keyframes pulseDot {
      0%, 100% { transform: scale(0.7); opacity: 0.28; }
      50% { transform: scale(1); opacity: 1; }
    }

    .native-toast {
      position: fixed;
      left: 50%;
      bottom: calc(16px + env(safe-area-inset-bottom));
      z-index: 80;
      width: min(calc(100vw - 28px), 500px);
      min-height: 50px;
      padding: 12px 15px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      color: #fff;
      background: rgba(20, 20, 20, 0.94);
      box-shadow: var(--shadow-subtle);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      transform: translateX(-50%);
      animation: toastUp 220ms ease-out both;
      font-size: 13px;
      font-weight: 720;
    }

    .native-toast.toast-erro {
      background: rgba(216, 58, 69, 0.95);
    }

    .native-toast.toast-aviso {
      background: rgba(196, 122, 36, 0.96);
    }

    @keyframes toastUp {
      from { opacity: 0; transform: translate(-50%, 16px); }
      to { opacity: 1; transform: translate(-50%, 0); }
    }

    .sheet-layer {
      position: fixed;
      inset: 0;
      z-index: 60;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 14px;
    }

    .sheet-backdrop {
      position: absolute;
      inset: 0;
      border: 0;
      background: rgba(20, 20, 20, 0.28);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      animation: fadeIn 160ms ease-out both;
    }

    .native-sheet {
      position: relative;
      z-index: 1;
      width: min(100%, 620px);
      max-height: min(88vh, 740px);
      overflow: auto;
      overscroll-behavior: contain;
      border-radius: 30px 30px 24px 24px;
      padding: 10px 16px 16px;
      background: var(--surface);
      border: 1px solid rgba(255, 255, 255, 0.7);
      box-shadow: 0 -18px 54px rgba(20, 20, 20, 0.20);
      animation: sheetEnter 220ms cubic-bezier(.2,.82,.2,1) both;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes sheetEnter {
      from { opacity: 0; transform: translateY(32px); }
      to { opacity: 1; transform: translateY(0); }
    }

    .sheet-grabber {
      width: 42px;
      height: 5px;
      margin: 0 auto 14px;
      border-radius: 999px;
      background: rgba(20, 20, 20, 0.14);
    }

    .sheet-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 14px;
    }

    .sheet-head p {
      margin: 0 0 4px;
      color: var(--muted);
      font-size: 11px;
      font-weight: 720;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .sheet-head h2 {
      margin: 0;
      color: var(--text);
      font-size: 25px;
      line-height: 1;
      letter-spacing: -0.065em;
      font-weight: 820;
    }

    .sheet-form {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }

    .floating-field {
      position: relative;
      min-width: 0;
    }

    .floating-field input,
    .floating-field select {
      width: 100%;
      height: 54px;
      border: 1px solid var(--line);
      border-radius: 18px;
      outline: 0;
      color: var(--text);
      background: var(--surface-soft);
      box-shadow: none;
      padding: 21px 14px 7px;
      font-size: 14px;
      font-weight: 640;
      transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
    }

    .floating-field select {
      appearance: none;
      -webkit-appearance: none;
      padding-right: 38px;
      cursor: pointer;
    }

    .select-field::after {
      content: "";
      position: absolute;
      right: 16px;
      top: 24px;
      width: 8px;
      height: 8px;
      border-right: 2px solid rgba(20,20,20,0.42);
      border-bottom: 2px solid rgba(20,20,20,0.42);
      transform: rotate(45deg);
      pointer-events: none;
    }

    .floating-field label {
      position: absolute;
      left: 14px;
      top: 8px;
      color: var(--muted);
      font-size: 11px;
      line-height: 1;
      font-weight: 720;
      pointer-events: none;
      transition: color 150ms ease;
    }

    .floating-field input:focus,
    .floating-field select:focus {
      background: #fff;
      border-color: rgba(20, 20, 20, 0.22);
      box-shadow: 0 0 0 4px rgba(20, 20, 20, 0.045);
    }

    .floating-field input:focus + label,
    .floating-field select:focus + label {
      color: var(--text);
    }

    .choice-grid {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }

    .choice-card {
      min-height: 72px;
      padding: 13px 14px;
      border-radius: 20px;
      border: 1px solid var(--line);
      background: var(--surface-soft);
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
      box-shadow: none;
      cursor: pointer;
      transition: transform 150ms ease, border-color 150ms ease, background 150ms ease;
    }

    .choice-card:active {
      transform: scale(0.98);
    }

    .choice-card input {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    .choice-card span {
      color: var(--text);
      font-size: 14px;
      font-weight: 760;
      letter-spacing: -0.025em;
    }

    .choice-card small {
      color: var(--muted);
      font-size: 12px;
      font-weight: 540;
    }

    .choice-card.active {
      color: #fff;
      border-color: var(--brand);
      background: var(--brand);
    }

    .choice-card.active span,
    .choice-card.active small {
      color: #fff;
    }

    .choice-card.active small {
      opacity: 0.64;
    }

    .sheet-submit {
      grid-column: 1 / -1;
      height: 56px;
      border: 0;
      border-radius: 20px;
      color: #fff;
      background: var(--brand);
      box-shadow: none;
      font-size: 15px;
      font-weight: 760;
      letter-spacing: -0.02em;
      transition: transform 150ms ease, opacity 150ms ease;
    }

    .sheet-submit:active:not(:disabled) {
      transform: scale(0.985);
    }

    .sheet-submit:disabled {
      opacity: 0.56;
      cursor: not-allowed;
    }

    @media (min-width: 900px) {
      .native-shell {
        padding-top: 22px;
      }

      .native-header {
        position: relative;
        background: transparent;
        padding-bottom: 16px;
      }

      .native-main {
        display: grid;
        grid-template-columns: minmax(300px, 0.78fr) minmax(0, 1.22fr);
        align-items: start;
        gap: 14px;
      }

      .account-hero {
        min-height: 170px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
      }

      .hero-action {
        align-self: flex-start;
      }

      .metric-grid {
        grid-column: 1 / 2;
        grid-template-columns: 1fr;
      }

      .team-panel {
        grid-column: 2 / 3;
        grid-row: 1 / span 2;
        min-height: 560px;
      }

      .sheet-layer {
        align-items: center;
      }

      .native-sheet {
        border-radius: 30px;
        box-shadow: 0 24px 80px rgba(20, 20, 20, 0.24);
      }
    }

    @media (max-width: 720px) {
      .native-shell {
        padding: 8px 12px 30px;
      }

      .native-header {
        grid-template-columns: 42px 1fr 42px;
      }

      .account-hero {
        padding: 18px;
        border-radius: 26px;
      }

      .account-hero h1 {
        font-size: 31px;
      }

      .hero-action {
        display: none;
      }

      .metric-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
      }

      .metric-card {
        min-height: 76px;
        padding: 12px;
        border-radius: 20px;
      }

      .metric-card strong {
        font-size: 25px;
      }

      .metric-card small {
        display: none;
      }

      .team-panel {
        border-radius: 26px;
        padding: 13px;
      }

      .panel-head h2 {
        font-size: 20px;
      }

      .search-pill {
        height: 44px;
      }

      .person-card {
        grid-template-columns: 1fr;
        gap: 9px;
        padding: 12px 0;
      }

      .person-side {
        justify-content: space-between;
        padding-left: 56px;
      }

      .native-status {
        font-size: 10px;
      }

      .mini-action {
        width: 34px;
        height: 34px;
        border-radius: 13px;
        background: var(--surface-soft);
      }

      .native-toast {
        bottom: calc(14px + env(safe-area-inset-bottom));
      }

      .sheet-layer {
        padding: 0;
      }

      .native-sheet {
        width: 100%;
        max-height: 90vh;
        border-radius: 28px 28px 0 0;
        padding: 10px 14px calc(16px + env(safe-area-inset-bottom));
      }

      .sheet-head h2 {
        font-size: 24px;
      }

      .sheet-form {
        grid-template-columns: 1fr;
      }

      .choice-grid {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 420px) {
      .native-shell {
        padding-left: 10px;
        padding-right: 10px;
      }

      .account-hero h1 {
        font-size: 29px;
      }

      .account-hero span {
        font-size: 12px;
      }

      .person-avatar {
        width: 42px;
        height: 42px;
        border-radius: 15px;
      }

      .person-side {
        padding-left: 54px;
      }

      .admin-pill {
        display: none;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      *,
      *::before,
      *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        scroll-behavior: auto !important;
        transition-duration: 0.01ms !important;
      }
    }
  `}</style>
);
